export default "__VITE_ASSET__BeF4JKc1__"